<template>
  <div>
    <breadcrumbPage></breadcrumbPage>
    <div class="content">
      <div class="display_flex EC_width">
        <div class="leftVideo">
          <img src="/image/quanke/videobanner.png"
               class="videoImg">
          <img src="/image/quanke/play.png"
               class="videoPlay">
        </div>
        <div class="flex1 marginLeft40 display_column_between">
          <p class="titleVideo"><span class="signBtn">免费</span>{{apiData.title}}</p>
          <div>
            <p class="grayColor">讲者：{{apiData.author}}</p>
            <p class="grayColor">单位：{{apiData.company}}</p>
            <p class="grayColor"><img src="/image/geren/ren.png"
                   class="marginRight5">12个人学过</p>
          </div>
          <div class="signBig">
            <span>{{apiData.price}}</span>
            <span class="yuanjia">{{apiData.originalPrice}}</span>
          </div>
          <div class="btnWrap">
            <div class="btnborder marginRight5">
              立即购买
            </div>
            <div class="btnbg marginRight5">
              加入购物车
            </div>
            <div class="btnred marginRight5">
              VIP免费看 >>
            </div>
          </div>
        </div>
        <div>
          <span class="marginRight20"><img src="/image/quanke/fenxiang.png"
                 class="marginRight5">分享</span>
          <span><img src="/image/quanke/xingxing.png"
                 class="marginRight5">收藏</span>
        </div>
      </div>
      <custom-modal width="560px"
                    :showmodal.sync="orderPrice">
        <div class="border_bottom_18">
          <span class="mTitle">确认订单信息</span>
          <span class="mSub marginLeft10">请在24小时内完成支付，否则订单将会取消</span>
        </div>
        <div class="mBlock">
          <img src="/image/quanke/orderhead.png"
               alt="">
          <div class="marginLeft10">
            <p class="fontsize16 fontBold marginBottom10">帐号：181****2225</p>
            <p class="fontsize14"
               style="color: #8F8F8F;">购买后不支持退款，转让，请确认好开课时间或有效期再提交订单</p>
          </div>
        </div>
        <div class="mBlock">
          <img src="/image/quanke/ordervideo.png"
               alt="">
          <div class="marginLeft10 flex1">
            <p class="fontsize14">美国家庭医学培训的主要临床技能</p>
          </div>
          <div class="fontsize14 display_center_ud"
               style="color: #666666;">
            ¥389
          </div>
        </div>
        <div class="marginTop20">
          <span class="mTitle">支付方式</span>
        </div>
        <div class="marginTop10">
          <el-radio v-model="payment"
                    label="1"><img src="/image/quanke/weixin.png"
                 style="vertical-align: -6px;margin-right: 6px"
                 alt="">微信</el-radio>
          <el-radio v-model="payment"
                    label="2"><img src="/image/quanke/zhifubao.png"
                 style="vertical-align: -6px;margin-right: 6px"
                 alt="">支付宝</el-radio>
        </div>
        <div class="display_between">
          <div></div>
          <div>
            <p class="fontsize14">商品总额：¥389</p>
            <p class="fontsize14 normalColor">实付款：¥289</p>
            <div class="priceBtn">立即付款</div>
          </div>
        </div>
      </custom-modal>
      <div class="EC_width display_flex marginTop50">
        <div class="flex1">
          <div class="gl_title_bar marginBottom20">
            <div class="gl_tb_left">
              <span class="tagTitle"
                    :class="{tagTitleActive:tagIndex==0}"
                    @click="taggleMenu(0)">课程介绍</span>
              <span class="tagTitle"
                    :class="{tagTitleActive:tagIndex==1}"
                    @click="taggleMenu(1)">讨论区</span>
            </div>
          </div>
          <img src="/image/quanke/tipsimg.png">
        </div>
        <div style="width: 300px;margin-left: 70px;">
          <div class="gl_title_bar marginBottom20">
            <div class="gl_tb_left">
              <span class="normaltitle">授课专家</span>
            </div>
            <div class="gl_tb_right">
              <a href="javascript:;"
                 class="gl_tb_right_more"><img src="/image/index/moreimg.png"
                     class="gltb_moreimg">更多</a>
            </div>
          </div>
          <div class="headWrap display_center">
            <img :src="apiData.expertHead"
                 alt="">
          </div>
          <div class="jieshao display_center_ud display_column">
            <p class="fontsize22 fontBold marginTop20 marginBottom10">{{apiData.expertName}}</p>
            <p>{{apiData.expertIntro}}</p>
          </div>
          <div class="gl_title_bar marginBottom20 marginTop40">
            <div class="gl_tb_left">
              <span class="normaltitle">相关课程</span>
            </div>
            <div class="gl_tb_right">
              <a href="javascript:;"
                 class="gl_tb_right_more"><img src="/image/index/moreimg.png"
                     class="gltb_moreimg">更多</a>
            </div>
          </div>
          <div class="pub_square marginBottom20"
               v-for="(item,index) in apiData.course"
               :key="index">
            <div class="pubs_img">
              <img src="/image/geren/testimg.png">
            </div>
            <div class="pubs_body">
              <div class="pubs_title">
                {{item.title}}
              </div>
              <div class="pubs_label display_between">
                <div>
                  <span v-for="(itemn,indexn) in item.sign"
                        :key="indexn">{{itemn}}</span>
                </div>
                <div class="pubs_cancel">
                  取消收藏
                </div>
              </div>
              <div class="display_between">
                <div class="pubs_tip">
                  <span class="redColor">{{item.price}}</span>
                </div>
                <div class="pubs_rentou">
                  <img src="/image/geren/ren.png">{{item.num}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import breadcrumbPage from "../home/breadcrumbPage"
export default {
  name: "qkCourseDetails",
  components: {
    breadcrumbPage
  },
  data () {
    return {
      orderPrice: true,
      apiData: {},
      payment: "1",
      tagIndex: 0
    }
  },
  created () {
    this.getData()

  },
  methods: {
    taggleMenu (index) {
      this.tagIndex = index
    },
    getData () {
      var that = this;
      fetch("/data.json").then((res) => {
        return res.json()
      }).then(data => {
        that.apiData = data.qkCourseDetails
      })
    },
  }
}
</script>

<style scoped>
.content {
    flex: 1;
    padding-top: 40px;
}
.leftVideo {
    position: relative;
    height: 275px;
    line-height: 337px;
    text-align: center;
    width: 425px;
}
.videoImg {
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
}
.videoPlay {
    cursor: pointer;
}
.titleVideo {
    font-size: 26px;
    font-family: Microsoft YaHei;
    font-weight: bold;
}
.signBtn {
    display: inline-block;
    height: 26px;
    background: #e60012;
    border-radius: 3px;
    color: #fff;
    text-align: center;
    line-height: 26px;
    padding: 0 8px;
    margin-right: 8px;
    font-size: 14px;
    vertical-align: 3px;
}
.signBig {
    font-size: 34px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #0b8586;
}
.yuanjia {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    text-decoration: line-through;
    color: #666666;
}
.btnborder {
    display: inline-block;
    width: 180px;
    height: 40px;
    background: #def3f3;
    border: 1px solid #0b8586;
    border-radius: 3px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #0b8586;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
}
.btnbg {
    display: inline-block;
    width: 180px;
    height: 40px;
    background: #0b8586;
    border-radius: 3px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #fff;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
}
.btnred {
    display: inline-block;
    width: 180px;
    height: 40px;
    background: #e60012;
    border-radius: 3px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #fff;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
}
.headWrap {
    width: 300px;
    height: 240px;
    background: url(/image/quanke/vheadbg.png) center no-repeat;
}
.jieshao {
    width: 301px;
    height: 90px;
    background: rgba(255, 255, 255, 0);
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.04);
}
.mTitle {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    line-height: 28px;
}
.mSub {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #0b8586;
    line-height: 28px;
}
.mBlock {
    padding: 10px 0;
    border-bottom: 1px solid #ddd;
    display: flex;
}
.priceBtn {
    width: 130px;
    height: 35px;
    background: #0b8586;
    border-radius: 3px;
    text-align: center;
    line-height: 35px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
    margin-top: 20px;
}
</style>
